import { ThemeProvider, CssBaseline } from '@mui/material';
import { darkTheme } from './styles/theme';
import Header from './components/Header/Header';
import Layout from './components/Layout/Layout';
import Home from './components/Home/Home';
import About from './components/About/About';
import Skills from './components/Skills/Skills';
import Projects from './components/Projects/Projects';
import Contact from './components/Contact/Contact';

function App() {
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <div id="back-to-top-anchor" />
      <Layout>
        <Home id="home" />
        <About id="about" />
        <Skills id="skills" />
        <Projects id="projects" />
        <Contact id="contact" />
      </Layout>
    </ThemeProvider>
  );
}

export default App;
